module.exports = __webpack_public_path__ + "img/statement2.891c8f43.png";